import { render } from "./Residents.vue?vue&type=template&id=ca4f011c"
import script from "./Residents.vue?vue&type=script&lang=js"
export * from "./Residents.vue?vue&type=script&lang=js"
script.render = render

export default script